import React, { useState, useEffect } from "react";
import styled from "styled-components";
import logo2 from "./logo2.jpg";
import pol from "./logopoliza.png";
import rec from "./reclamosgm.png";
import pag from "./pagos.png";
import ase from "./ase.png";
import all from "./all.png";
import asistente_uno from "./colaboradores/1229.JPG";
import asistente_dos from "./colaboradores/1161.JPG";
import asistente_tres from "./colaboradores/1040.jpeg";
import gerente_uno from "./colaboradores/1220.jpg";
import reclamos_uno from "./colaboradores/1113.JPG";
import reclamos_dos from "./colaboradores/1255.jpeg";
import reclamos_tres from "./colaboradores/1257.JPG";
import reclamos_cuatro from "./colaboradores/1281.jpg";
import reclamos_cinco from "./colaboradores/1288.jpeg";
import reclamos_seis from "./colaboradores/1276.jpg";
import reclamos_siete from "./colaboradores/1271.jpeg";
import reclamos_ocho from "./colaboradores/1246.jpeg";
import reclamos_nueve from "./colaboradores/1267.jpg";
import reclamos_diez from "./colaboradores/973.jfif";
import reclamos_once from "./colaboradores/322.jpg";
import reclamos_doce from "./colaboradores/300.jpg";
import reclamos_trece from "./colaboradores/1207.jpg";
import reclamos_catorce from "./colaboradores/1170.JPG";
import reclamos_1361 from "./colaboradores/1361.jpg";
import reclamos_1113 from "./colaboradores/1113.JPG"; //Evelyn Mazariegos 
import reclamos_1333 from "./colaboradores/1333.jpg"; // Mónica Albeño
import reclamos_1347 from "./colaboradores/1347.jpg"; //Heidi Hernández 
import gerente_dos from "./colaboradores/861.png";
import asistente_cuatro from "./colaboradores/929.JPG";
import asistente_cinco from "./colaboradores/559.JPG";
import asistente_seis from "./colaboradores/1439.jpg";
import asistente_siete from "./colaboradores/361.JPG";
import asistente_diecinueve from "./colaboradores/928.jfif";
import asistente_ocho from "./colaboradores/1184.jpeg";
import asistente_nueve from "./colaboradores/1112.JPG";
import asistente_diez from "./colaboradores/1181.JPG";
import asistente_once from "./colaboradores/1298.jpeg";
import asistente_doce from "./colaboradores/1300.jpeg";
import asistente_trece from "./colaboradores/1104.jfif";
import asistente_catorce from "./colaboradores/1268.jpeg";
import asistente_quince from "./colaboradores/1304.jpg";
import asistente_dieciseis from "./colaboradores/1306.jpg";
import asistente_diecisiete from "./colaboradores/1307.jpg";
import asistente_dieciocho from "./colaboradores/1311.jpg";
import asistente_veitiuno from "./colaboradores/202.JPG";
import asistente_veinte from "./colaboradores/369.jpg";
import asistente_veinticinco from "./colaboradores/726.JPG";
import asistente_veintiseis from "./colaboradores/1240.jpeg";
import gerente_tres from "./colaboradores/70.jpg";
import gerente_cuatro from "./colaboradores/96.jpg";
import gerente_cinco from "./colaboradores/968.JPG";
import gerente_seis from "./colaboradores/1083.jpeg";
import asistente_veintidos from "./colaboradores/726.JPG";
import asistente_veintitres from "./colaboradores/876.jpeg";
import ejemplo from "./ejemplo.jpg";
import ReactStars from "react-rating-stars-component";
import "./styles.css";
import asi from "./LOGOGYT.png";
import { MultiStepForm, Step } from "react-multi-form";
import { Button } from "reactstrap";
import Forms from "./Forms.js";
import Parte1 from "./parte1.js";
import Parte2 from "./parte2.js";
import TablaPoliza from "./TablaPoliza.js";
import TablaDep from "./TablaDep.js";
import TablaBen from "./TabBen.js";
import axios, { AxiosRequestConfig } from "./axios-config";
import swal from "sweetalert";
import $ from "jquery";
import LoadingOverlay from "react-loading-overlay";
import BounceLoader from "react-spinners/RingLoader";
import Moment from "moment";
import "moment/locale/es";
import loader from "./pageLoader.gif";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaUserAlt, FaMailBulk, FaPhoneAlt, FaAddressCard, FaMapMarker, FaCalculator, FaEnvelope, FaClock } from "react-icons/fa";
import Califica from "./calificacion.js";
import Select from "react-select";
import {
  Card,
  CardBody,
  CardImg,
  CardTitle,
  CardText,
  CardHeader,
  CardFooter,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
  width: 100%;
  padding: 10px;
  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

const ProfileCard = styled.div`
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  position: relative;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
  height: 100%;
`;

const ProfileHeader = styled.div`
  background: #eef2f6;
  height: 85px;
  width: 100%;
`;

const ProfileAvatar = styled.div`
  width: 90px;
  height: 90px;
  border-radius: 50%;
  border: 4px solid #ffffff;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
  position: absolute;
  top: 40px;
  left: 50%;
  transform: translateX(-50%);
  background: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const ProfileBody = styled.div`
  padding: 60px 20px 20px;
  text-align: center;
  flex-grow: 1;
`;

const TitleBadge = styled.div`
  display: inline-block;
  background: #f1f5f9;
  color: #475569;
  padding: 5px 16px;
  border-radius: 20px;
  font-weight: 700;
  font-size: 0.65rem;
  letter-spacing: 1px;
  margin-bottom: 12px;
  text-transform: uppercase;
`;

const ProfileName = styled.h3`
  font-size: 1.15rem;
  color: #0f172a;
  font-weight: 700;
  margin-bottom: 25px;
`;

const InfoPill = styled.div`
  display: flex;
  align-items: center;
  background: #eff6ff;
  border-radius: 6px;
  padding: 10px 15px;
  margin-bottom: 10px;
  text-align: left;
  border: 1px solid #e0e7ff;

  .icon-wrapper {
    color: #1e3a8a;
    font-size: 1rem;
    margin-right: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  span, a {
    font-size: 0.85rem;
    color: #1e293b;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-decoration: none;
  }

  a:hover {
    color: #0050b3;
    text-decoration: underline;
  }
`;

const Poliza = () => {
  let validacion = 0;
  const [Asistente, setAsistente] = useState([]);
  const [Gerente, setGerente] = useState([]);
  const [Reclamo, setReclamo] = useState([]);
  let asistente = "";
  let gerente = "";
  useEffect(async () => {
    //ocultamos el dive del asesor y se muestra unicamente cuando sea de daños la póliza
    // y eso se ve en la parte donde tenemos  $("#div_asesor").show(); 
    $("#div_asesor").hide();
    let datos = [];
    let sex = "";
    let mivariblease = "";
    let parentesco = "";
    let usr_dan = "";

    $("#info").hide();
    $("#info2").hide();
    $("#info3").hide();
    $("#datGen").hide();
    //console.log("idepol: ",$("#idepol").val());
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/it-api-clientes2/rs/operaciones/asesor/` +
        $("#idepol").val(), {
        headers: {
          'Authorization': `Bearer ${sessionStorage.getItem('jwtToken')}`,
        },
      }
      )
      .then((json) => {
        if (json.status === 200) {
          //console.log("aqui estoy");
          $("#nom_asis").text(json.data.asistentesTable[0].nombre);
          $("#email_asis")
            .attr("href", "mailto:" + json.data.asistentesTable[0].email)
            .attr("target", "_blank");
          $("#mail_asis").text(json.data.asistentesTable[0].email);
          $("#puesto_asis").text(json.data.asistentesTable[0].codigoPuesto);
          $("#telefono_asis").text(
            "(502) " +
            json.data.asistentesTable[0].telefonoDirecto +
            " Ext. " +
            json.data.asistentesTable[0].extension
          );
          $("#whatsapp_asis").text("(502) " + 22856501);
          //console.log(json.data.asistentesTable[0].codigoAsistente);
          if (json.data.asistentesTable[0].codigoAsistente === 1229) {
            $("#col_what").hide();
            setAsistente(asistente_uno);
            $("#pu_asis").text("Asesor Negocios Personas");

            axios
              .get(
                `${process.env.REACT_APP_API_URL}/it-api-clientes2/rs/operaciones/asesorGerente/` +
                1220, {
                headers: {
                  'Authorization': `Bearer ${sessionStorage.getItem('jwtToken')}`,
                },
              }
              )
              .then((json) => {
                if (json.status === 200) {
                  $("#div_asesor").hide();
                  setGerente(gerente_uno);
                  $("#nom_gers").text(json.data.asistentesTable[0].nombre);
                  $("#email_ger")
                    .attr("href", "mailto:" + json.data.asistentesTable[0].email)
                    .attr("target", "_blank");
                  $("#mail_ger").text(json.data.asistentesTable[0].email);
                  $("#puesto_ger").text(json.data.asistentesTable[0].codigoPuesto);
                  $("#telefono_ger").text(
                    "(502) " +
                    json.data.asistentesTable[0].telefonoDirecto +
                    " Ext. " +
                    json.data.asistentesTable[0].extension
                  );
                  $("#whatsapp_ger").text("(502) " + 22856501);
                  $("#pu_ger").text("Gerente de Negocios Personas");
                } else {
                  swal(
                    "Error",
                    "No se encontro información de  Gerente",
                    "warning"
                  );
                }
              })
              .catch(function (error) {
                swal(
                  "Error",
                  "No eee encontro  información de Gerente",
                  "warning"
                );
              });
          } else if (json.data.asistentesTable[0].codigoAsistente === 726) {
            $("#div_reclamos").hide();
            $("#col_what").hide();
            setAsistente(asistente_veinticinco);
            $("#pu_asis").text("Asesor Negocios Daños");

            axios
              .get(
                `${process.env.REACT_APP_API_URL}/it-api-clientes2/rs/operaciones/asesorGerente/` +
                968, {
                headers: {
                  'Authorization': `Bearer ${sessionStorage.getItem('jwtToken')}`,
                },
              }
              )
              .then((json) => {
                if (json.status === 200) {
                  setGerente(gerente_cinco);
                  $("#nom_gers").text(json.data.asistentesTable[0].nombre);
                  $("#email_ger")
                    .attr("href", "mailto:" + json.data.asistentesTable[0].email)
                    .attr("target", "_blank");
                  $("#mail_ger").text(json.data.asistentesTable[0].email);
                  $("#puesto_ger").text(json.data.asistentesTable[0].codigoPuesto);
                  $("#telefono_ger").text(
                    "(502) " +
                    json.data.asistentesTable[0].telefonoDirecto +
                    " Ext. " +
                    json.data.asistentesTable[0].extension
                  );
                  $("#whatsapp_ger").text("(502) " + 22856501);
                  $("#pu_ger").text("Gerente de Negocios Daños");
                } else {
                  swal(
                    "Error",
                    "No se encontro información de  Gerente",
                    "warning"
                  );
                }
              })
              .catch(function (error) {
                swal(
                  "Error",
                  "No eee encontro  información de Gerente",
                  "warning"
                );
              });
          } else if (
            $("#tipoPol").val() === "VA" ||
            $("#tipoPol").val() === "CERT" ||
            $("#tipoPol").val() === "MM" ||
            $("#tipoPol").val() === "EE" ||
            $("#tipoPol").val() === "INCEN" ||
            $("#tipoPol").val() === "TDINCEN" ||
            $("#tipoPol").val() === "FA" ||
            $("#tipoPol").val() === "RC"
          ) {
            $("#div_asesor").show();
            // console.log("PRIMER IF");
            $("#info").show();
            $("#info2").show();
            $("#info3").show();
            //$("#div_gerente").show();
            $("#div_reclamos").hide();
            //$("#div_gerente").removeClass();
            //$("#div_gerente").addClass("col-xs-12 col-md-6");
            //$("#div_asesor").removeClass();
            //$("#div_asesor").addClass("col-xs-12 col-md-6");            
            switch (String(json.data.asistentesTable[0].codigoAsistente)) {
              case "1439":
                setAsistente(asistente_seis);
                usr_dan = "3333332";
                break;
              case "559":
                setAsistente(asistente_cinco);
                usr_dan = "3333331";
                break;
              case "929":
                setAsistente(asistente_cuatro);
                usr_dan = "3333333";
                break;
              case "361":
                setAsistente(asistente_siete);
                usr_dan = "3333334";
                break;
              case "928":
                setAsistente(asistente_diecinueve);
                usr_dan = "3333335";
                break;
              case "1184":
                setAsistente(asistente_ocho);
                usr_dan = "3333336";
                break;
              case "1112":
                setAsistente(asistente_nueve);
                usr_dan = "3333337";
                break;
              case "1181":
                setAsistente(asistente_diez);
                usr_dan = "3333338";
                break;
              case "1298":
                setAsistente(asistente_once);
                usr_dan = "3333339";
                break;
              case "1300":
                setAsistente(asistente_doce);
                usr_dan = "3333340";
                break;
              case "1104":
                setAsistente(asistente_trece);
                usr_dan = "3333341";
                break;
              case "1268":
                setAsistente(asistente_catorce);
                usr_dan = "3333342";
                break;
              case "1304":
                setAsistente(asistente_quince);
                usr_dan = "3333342";
                break;
              case "1306":
                setAsistente(asistente_dieciseis);
                usr_dan = "3333342";
                break;
              case "1307":
                setAsistente(asistente_diecisiete);
                usr_dan = "3333342";
                break;
              case "1311":
                setAsistente(asistente_dieciocho);
                usr_dan = "3333342";
                break;
              case "202":
                setAsistente(asistente_veitiuno);
                usr_dan = "3333343";
                break;
              case "369":
                setAsistente(asistente_veinte);
                usr_dan = "3333344";
                break;
              case "726":
                setAsistente(asistente_veintidos);
                usr_dan = "3333345";
                break;
              case "876":
                setAsistente(asistente_veintitres);
                usr_dan = "3333346";
                break;
            }

            $("#pu_asis").text("Asesor Negocios Daños");
            $("#col_what").show();
            /*
            axios
              .get(
                `${process.env.REACT_APP_API_URL}/it-api-clientes2/rs/operaciones/usuario_reclamo/` +
                  usr_dan,{
                    headers: {
                      'Authorization': `Bearer ${sessionStorage.getItem('jwtToken')}`,
                    },
                  }
              )
              .then((json) => {
                $("#whatsapp_asis").text("(502)  " + json.data.contacto);
                $("#what")
                  .attr("href", "https://wa.me/502" + json.data.contacto)
                  .attr("target", "_blank");
              });*/
            let dato_gerente;

            if ($("#idclienteF").val() == 2391) {
              dato_gerente = 968;
              setGerente(gerente_cinco);
            } else {
              dato_gerente = 96;
              setGerente(gerente_cuatro);
            }
            axios
              .get(
                `${process.env.REACT_APP_API_URL}/it-api-clientes2/rs/operaciones/asesorGerente/` +
                dato_gerente, {
                headers: {
                  'Authorization': `Bearer ${sessionStorage.getItem('jwtToken')}`,
                },
              }
              )
              .then((json) => {
                if (json.status === 200) {
                  let dato;
                  switch (String(json.data.asistentesTable[0].codigoPuesto)) {
                    case "2":
                      dato = "Gerente de Negocios Daños";
                      break;
                    case "7":
                      dato = "Gerente de Negociación Regional";
                  }
                  setGerente(gerente_cuatro);
                  $("#nom_gers").text(json.data.asistentesTable[0].nombre);
                  $("#email_ger")
                    .attr("href", "mailto:" + json.data.asistentesTable[0].email)
                    .attr("target", "_blank");
                  $("#mail_ger").text(json.data.asistentesTable[0].email);
                  $("#puesto_ger").text(json.data.asistentesTable[0].codigoPuesto);
                  $("#telefono_ger").text(
                    "(502) " +
                    json.data.asistentesTable[0].telefonoDirecto +
                    " Ext. " +
                    json.data.asistentesTable[0].extension
                  );
                  // $('#whatsapp_ger').text('(502) '+22856501);
                  $("#pu_ger").text(dato);
                } else {
                  swal(
                    "Error",
                    "No se encontro información de  Gerente",
                    "warning"
                  );
                }
              })
              .catch(function (error) {

                swal(
                  "Error",
                  "No eee encontro  información de Gerente",
                  "warning"
                );
              });
          } else if (json.data.asistentesTable[0].codigoAsistente === 1161) {
            setAsistente(asistente_dos);
            $("#col_what").hide();

            $("#pu_asis").text("Asesor Negocios Personas");
            axios
              .get(
                `${process.env.REACT_APP_API_URL}/it-api-clientes2/rs/operaciones/asesorGerente/` +
                861, {
                headers: {
                  'Authorization': `Bearer ${sessionStorage.getItem('jwtToken')}`,
                },
              }
              )
              .then((json) => {
                if (json.status === 200) {
                  setGerente(gerente_dos);
                  $("#nom_gers").text(json.data.asistentesTable[0].nombre);
                  $("#email_ger")
                    .attr(
                      "href",
                      "mailto:" +
                      json.data.asistentesTable[0].email +
                      "?subject=Consulta de póliza: " +
                      $("#polizaCompleta").val().replace("&", "y")
                    )
                    .attr("target", "_blank");
                  $("#mail_ger").text(json.data.asistentesTable[0].email);
                  $("#puesto_ger").text(json.data.asistentesTable[0].codigoPuesto);
                  $("#telefono_ger").text(
                    "(502) " +
                    json.data.asistentesTable[0].telefonoDirecto +
                    " Ext. " +
                    json.data.asistentesTable[0].extension
                  );
                  $("#whatsapp_ger").text("(502) " + 22856501);
                  $("#pu_ger").text("Gerente de Negocios Personas");
                } else {
                  swal(
                    "Error",
                    "No se encontro información de  Gerente",
                    "warning"
                  );
                }
              })
              .catch(function (error) {
                swal(
                  "Error",
                  "No eee encontro  información de Gerente",
                  "warning"
                );
              });
          } else if (json.data.asistentesTable[0].codigoAsistente === 1040) {
            $("#col_what").hide();
            //$("#div_gerente").prop("class").replace("col-xs-12 col-md-4", "");
            //$("#div_gerente").hide();
            //$("#div_asesor").removeClass();
            //$("#div_asesor").addClass("col-xs-12 col-md-6");
            $("#div_reclamos").removeClass();
            $("#div_reclamos").addClass("col-xs-12 col-md-6");
            $("#pu_asis").text("Asesor Negocios Personas");
            setAsistente(asistente_tres);
            axios
              .get(
                `${process.env.REACT_APP_API_URL}/it-api-clientes2/rs/operaciones/asesorGerente/` +
                70, {
                headers: {
                  'Authorization': `Bearer ${sessionStorage.getItem('jwtToken')}`,
                },
              }
              )
              .then((json) => {
                if (json.status === 200) {
                  setGerente(gerente_tres);
                  $("#nom_gers").text(json.data.asistentesTable[0].nombre);
                  $("#email_ger")
                    .attr(
                      "href",
                      "mailto:" +
                      json.data.asistentesTable[0].email +
                      "?subject=Consulta de póliza: " +
                      $("#polizaCompleta").val().replace("&", "y")
                    )
                    .attr("target", "_blank");
                  $("#mail_ger").text(json.data.asistentesTable[0].email);
                  $("#puesto_ger").text(json.data.asistentesTable[0].codigoPuesto);
                  $("#telefono_ger").text(
                    "(502) " +
                    json.data.asistentesTable[0].telefonoDirecto +
                    " Ext. " +
                    json.data.asistentesTable[0].extension
                  );
                  $("#whatsapp_ger").text("(502) " + 22856501);
                  $("#pu_ger").text("Gerente de Negocios Personas");
                } else {
                  swal(
                    "Error",
                    "No se encontro información de  Gerente",
                    "warning"
                  );
                }
              })
              .catch(function (error) {
                swal(
                  "Aviso",
                  "No se encontro  información de Gerente",
                  "info"
                );
              });
          } else if (json.data.asistentesTable[0].codigoAsistente === 1240) {
            //console.log("SEGUNDO IF 1240");
            $("#col_what").hide();
            $("#div_gerente").show();            //$("#div_gerente").prop("class").replace("col-xs-12 col-md-4", "");
            //$("#div_gerente").show();
            //$("#div_asesor").removeClass();
            //$("#div_asesor").addClass("col-xs-12 col-md-6");
            $("#div_reclamos").removeClass();
            $("#div_reclamos").addClass("col-xs-12 col-md-6");
            $("#div_reclamos").hide();
            $("#pu_asis").text("Asesor Negocios Personas");
            setAsistente(asistente_veintiseis);
            axios
              .get(
                `${process.env.REACT_APP_API_URL}/it-api-clientes2/rs/operaciones/asesorGerente/` +
                1083, {
                headers: {
                  'Authorization': `Bearer ${sessionStorage.getItem('jwtToken')}`,
                },
              }
              )
              .then((json22) => {
                if (json22.status === 200) {
                  //console.log("json22: ",json22);
                  setGerente(gerente_seis);
                  $("#nom_gers").text(json22.data.asistentesTable[0].nombre);
                  $("#email_ger")
                    .attr(
                      "href",
                      "mailto:" +
                      json22.data.asistentesTable[0].email +
                      "?subject=Consulta de póliza: " +
                      $("#polizaCompleta").val().replace("&", "y")
                    )
                    .attr("target", "_blank");
                  $("#mail_ger").text(json22.data.asistentesTable[0].email);
                  $("#puesto_ger").text(json22.data.asistentesTable[0].codigoPuesto);
                  $("#telefono_ger").text(
                    "(502) " +
                    json22.data.asistentesTable[0].telefonoDirecto +
                    " Ext. " +
                    json22.data.asistentesTable[0].extension
                  );
                  $("#whatsapp_ger").text("(502) " + 22856501);
                  $("#pu_ger").text("Gerente de Negocios Personas");

                } else {
                  swal(
                    "Error",
                    "No se encontro información de  Gerente",
                    "warning"
                  );
                }
              })
              .catch(function (error) {
                swal(
                  "Aviso",
                  "No se encontro  información de Gerente",
                  "info"
                );
              });
          }
          else {
            /*swal(
              "Aviso",
              "No se encontró información de tu Gerente",
              "info"
            );*/
          }

          if (
            $("#tipoPol").val() === "VA" ||
            $("#tipoPol").val() === "CERT" ||
            $("#tipoPol").val() === "MM" ||
            $("#tipoPol").val() === "EE" ||
            $("#tipoPol").val() === "INCEN" ||
            $("#tipoPol").val() === "TDINCEN" ||
            $("#tipoPol").val() === "FA" ||
            $("#tipoPol").val() === "TR" ||
            $("#tipoPol").val() === "RC"
          ) {
            //console.log("productos daños");
          } else {
            axios
              .get(
                `${process.env.REACT_APP_API_URL}/it-api-clientes2/rs/operaciones/usuario_reclamo/` +
                $("#idepol").val(), {
                headers: {
                  'Authorization': `Bearer ${sessionStorage.getItem('jwtToken')}`,
                },
              }
              )
              .then((json) => {
                console.log("usuario_reclamo", JSON.stringify(json.data));
                if (json.status === 200) {
                  setReclamo(json.data.urlFotografia);
                  /*if (json.data.idAsistente === 1255) {
                    setReclamo(reclamos_dos);
                  } else if (json.data.idAsistente === 1257) {
                    setReclamo(reclamos_tres);
                  } else if (json.data.idAsistente === 1281) {
                    setReclamo(reclamos_cuatro);
                  } else if (json.data.idAsistente === 1288) {
                    setReclamo(reclamos_cinco);
                  } else if (json.data.idAsistente === 1276) { //Gerson Hernández
                    setReclamo(reclamos_seis);
                  } else if (json.data.idAsistente === 1271) {
                    setReclamo(reclamos_siete);
                  } else if (json.data.idAsistente === 1246) {
                    setReclamo(reclamos_ocho);
                  } else if (json.data.idAsistente === 1267) {
                    setReclamo(reclamos_nueve);
                  } else if (json.data.idAsistente === 973) {
                    setReclamo(reclamos_diez);
                  } else if (json.data.idAsistente === 322) {
                    setReclamo(reclamos_once);
                  } else if (json.data.idAsistente === 300) {
                    setReclamo(reclamos_doce);
                  } else if (json.data.idAsistente === 1207) {
                    setReclamo(reclamos_trece);
                  } else if (json.data.idAsistente === 1170) {
                    setReclamo(reclamos_catorce);
                  } else if (json.data.idAsistente === 1361) { // Nery Arana
                    setReclamo(reclamos_1361);
                  } else if (json.data.idAsistente === 1113) { //Evelyn Mazariegos
                    setReclamo(reclamos_1113);
                  } else if (json.data.idAsistente === 1333) { //Mónica Albeño
                    setReclamo(reclamos_1333);
                  } else if (json.data.idAsistente === 1347) {//Heidi Hernández
                    setReclamo(reclamos_1347);
                  }
                  else {
                    //setReclamo(reclamos_uno);
                  }*/

                  axios
                    .get(
                      `${process.env.REACT_APP_API_URL}/it-api-clientes2/rs/operaciones/asesorGerente/` +
                      json.data.idAsistente, {
                      headers: {
                        'Authorization': `Bearer ${sessionStorage.getItem('jwtToken')}`,
                      },
                    }
                    )
                    .then((jsonr) => {
                      if (jsonr.status === 200) {

                        $("#nom_rec").text(jsonr.data.asistentesTable[0].nombre);
                        // se agrega esta validación porque el asistene de reclamos 1361 es unicamente 
                        // para el cliente de claro y maneja un horario diferente a los demas asistentes
                        if (jsonr.data.asistentesTable[0].codigoAsistente === 1361) {
                          $("#horarioAsis1361").show();
                          $("#horarioAsisX").hide();
                        } else // en caso que no sea 1361 entonces ocultar el horario de ese asistente y mostrar el de los demas
                        {
                          $("#horarioAsis1361").hide();
                          $("#horarioAsisX").show();
                        }
                        $("#email_rec")
                          .attr(
                            "href",
                            "mailto:" +
                            jsonr.data.asistentesTable[0].email +
                            "?subject=Consulta de póliza: " +
                            $("#polizaCompleta").val().replace("&", "y")
                          )
                          .attr("target", "_blank");
                        $("#mail_rec").text(jsonr.data.asistentesTable[0].email);
                        $("#puesto_rec").text(
                          jsonr.data.asistentesTable[0].codigoPuesto
                        );
                        $("#telefono_rec").text(
                          "(502) " +
                            jsonr.data.asistentesTable[0].telefonoCelular ? jsonr.data.asistentesTable[0].telefonoCelular : ''
                        );
                        /* se comenta este bloque porque para mi seguro se debe mostrar el telefono celular
                        if(json.data.idAsistente === 1361) //Nery Arana de Claro mostrar su numero de celular
                        {
                          $("#telefono_rec").text(
                          "(502) " +
                            jsonr.data.asistentesTable[0].telefonoCelular
                        );
                        }else{ // para los demas asistentes
                          $("#telefono_rec").text(
                            "(502) " +
                              jsonr.data.asistentesTable[0].telefonoDirecto +
                              " Ext. " +
                              jsonr.data.asistentesTable[0].extension
                          );
                        }*/

                        $("#whatsapp_rec").text("(502) " + json.data.contacto);
                        $("#wh_rec").attr(
                          "href",
                          "tel:502" + json.data.contacto
                        );
                      } else {
                        swal("Error", "No se encontró información", "warning");
                      }
                    });
                } else {
                  swal(
                    "Error",
                    "No se encontro información de  Asesor Reclamo",
                    "warning"
                  );
                }
              })
              .catch(function (error) {
                swal(
                  "Error",
                  "No eee encontro  información de Asesor Reclamo dos",
                  "warning"
                );
              });
          }
          //console.log(asistente);
          setTimeout(function () {
            //do something special
          }, 9000);
          //     setMiVariable(mivaribleDep);
        } else {
          swal("Error", "No se encontro información de  Asesor", "warning");
        }
      })
      .catch(function (error) {
        swal("Error", "Error: No se encontro  información de Asesor", "warning");
      });
  }, []);

  const secondExample = {
    size: 50,
    count: 10,
    color: "black",
    activeColor: "yellow",
    value: 7.5,
    a11y: true,
    isHalf: true,
    emptyIcon: <i className="far fa-star" />,
    halfIcon: <i className="fa fa-star-half-alt" />,
    filledIcon: <i className="fa fa-star" />,
    onChange: (newValue) => {
      //console.log(`Example 2: new value is ${newValue}`);
    },
  };

  const agregar_spinner_regional = (id_objeto) => {
    $("#" + id_objeto).addClass("overlay");
    $("#" + id_objeto).show();
  };

  const ratingChanged = (newRating) => {
    //console.log(newRating);
  };

  const limpiar_spinner = (id_objeto) => {
    //console.log("ingrese a limpieza");
    $("#" + id_objeto).removeClass("overlay");
    $("#" + id_objeto).html("");
    $("#" + id_objeto).hide();
  };

  const [active, setActive] = React.useState(1);
  const [loading, setLoading] = React.useState(false);
  return (
    <GridContainer>

      <div id="div_reclamos" name="div_reclamos">
        <ProfileCard>
          <ProfileHeader />
          <ProfileAvatar>
            {<img src={Reclamo} alt="logo" />}
          </ProfileAvatar>
          <ProfileBody>
            <TitleBadge>ASESOR DE RECLAMOS</TitleBadge>
            <ProfileName id="nom_rec" name="nom_rec"></ProfileName>

            <InfoPill>
              <div className="icon-wrapper"><FaEnvelope /></div>
              <a id="email_rec" name="email_rec" target="_blank" rel="noreferrer">
                <span id="mail_rec" name="mail_rec"></span>
              </a>
            </InfoPill>

            <InfoPill>
              <div className="icon-wrapper"><FaPhoneAlt /></div>
              <a rel="noreferrer">
                <span id="telefono_rec" name="telefono_rec"></span>
              </a>
            </InfoPill>

            <div id="horarioAsis1361" style={{ display: "none" }}>
              <InfoPill>
                <div className="icon-wrapper"><FaClock /></div>
                <span>Lun - Vier de 8:00 AM - 5:00 PM</span>
              </InfoPill>
            </div>
            <div id="horarioAsisX">
              <InfoPill>
                <div className="icon-wrapper"><FaClock /></div>
                <span>Lun - Vier de 8:00 AM - 5:00 PM</span>
              </InfoPill>
            </div>

          </ProfileBody>
        </ProfileCard>
      </div>

      <div id="div_asesor" name="div_asesor">
        <ProfileCard>
          <ProfileHeader />
          <ProfileAvatar>
            {Asistente.length !== 0 && <img src={Asistente} alt="logo" />}
          </ProfileAvatar>
          <ProfileBody>
            <TitleBadge id="pu_asis" name="pu_asis">ASESOR DE PÓLIZA</TitleBadge>
            <ProfileName id="nom_asis" name="nom_asis"></ProfileName>

            <InfoPill>
              <div className="icon-wrapper"><FaEnvelope /></div>
              <a id="email_asis" name="email_asis" target="_blank" rel="noreferrer">
                <span id="mail_asis" name="mail_asis"></span>
              </a>
            </InfoPill>

            <InfoPill>
              <div className="icon-wrapper"><FaPhoneAlt /></div>
              <a href="tel:+50223868310" target="_blank" rel="noreferrer">
                <span id="telefono_asis" name="telefono_asis"></span>
              </a>
            </InfoPill>

            <InfoPill>
              <div className="icon-wrapper"><FaClock /></div>
              <span>Lun - Vier de 8:00 AM - 5:00 PM</span>
            </InfoPill>
          </ProfileBody>
        </ProfileCard>
      </div>

      <div id="div_gerente" name="div_gerente" style={{ display: "none" }}>
        <ProfileCard>
          <ProfileHeader />
          <ProfileAvatar>
            {Gerente.length !== 0 && <img src={Gerente} alt="logo" />}
          </ProfileAvatar>
          <ProfileBody>
            <TitleBadge id="pu_ger" name="pu_ger">GERENTE</TitleBadge>
            <ProfileName id="nom_gers" name="nom_gers"></ProfileName>

            <InfoPill>
              <div className="icon-wrapper"><FaEnvelope /></div>
              <a id="email_ger" name="email_ger" target="_blank" rel="noreferrer">
                <span id="mail_ger" name="mail_ger"></span>
              </a>
            </InfoPill>

            <InfoPill>
              <div className="icon-wrapper"><FaPhoneAlt /></div>
              <a href="tel:+50223868310" target="_blank" rel="noreferrer">
                <span id="telefono_ger" name="telefono_ger"></span>
              </a>
            </InfoPill>

            <InfoPill>
              <div className="icon-wrapper"><FaClock /></div>
              <span>Lun - Vier de 8:00 AM - 5:00 PM</span>
            </InfoPill>
          </ProfileBody>
        </ProfileCard>
      </div>

    </GridContainer>
  );
};

export default Poliza;
